import { Platform } from 'react-native';

const isWeb = Platform.OS === 'web';
let SecureStore;

if (!isWeb) {
    SecureStore = require('expo-secure-store');
}

const setItem = async (key, value) => {
    if (isWeb) {
        try {
            localStorage.setItem(key, value);
        } catch (e) {
            console.error('Local storage unavailable', e);
        }
    } else {
        if (SecureStore) {
            await SecureStore.setItemAsync(key, value);
        }
    }
};

const getItem = async (key) => {
    if (isWeb) {
        if (typeof localStorage !== 'undefined') {
            return localStorage.getItem(key);
        }
        return null;
    } else {
        if (SecureStore) {
            return await SecureStore.getItemAsync(key);
        }
        return null;
    }
};

const deleteItem = async (key) => {
    if (isWeb) {
        if (typeof localStorage !== 'undefined') {
            localStorage.removeItem(key);
        }
    } else {
        if (SecureStore) {
            await SecureStore.deleteItemAsync(key);
        }
    }
};

export default { setItem, getItem, deleteItem };
